module.exports = __webpack_public_path__ + "static/img/04-06.21dc1d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/04-06.png
// module id = g9+r
// module chunks = 0